import { api } from 'app/utils/api/helpers'

export const createViewingRun = (teamGUID, runPreferences) => {
  return api.post(`sm/viewing-runs/${teamGUID}`, runPreferences)
}

export const updateViewingRun = (teamGUID, runId, runPreferences) => {
  return api.put(`sm/viewing-runs/${teamGUID}/${runId}`, runPreferences)
}
